import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import Formsy from 'formsy-react';
import { Info } from 'lucide-react';
import { Row, Col, Button, Label, FormGroup, DefaultTooltip, SheetBody, SheetFooter, Textarea, Badge } from 'twyne-new.ui';

import Select from 'components/form/Select';
import history from 'utils/history';

import { useIntegrationStore } from '../store';

import FileUploader from './FileUploader';

const emailsAreaMaxLength = 25000

class UnsubscribeForm extends React.Component {
  state = {
    integrationId: null,
    emailsField: '',
    emails: null
  }

  handleIntegrationChange = (item)=>{
    const integrationId = item.value
    this.setState({integrationId})
  }

  handleEmailsChange = isFile => evt => {
    const emails = this.validateEmails(isFile ? evt : evt.target.value)
    if (emails)
      this.setState({
        emails,
        emailsField: isFile ? null : evt.target.value
      })
  }

  handleValidSubmit = () => {
    let { emails, integrationId, emailsField } = this.state
    if (!emails)
      emails = emailsField.split('\n')
    this.props.handleSubmit({ emails, integrationId });
  }

  handleCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    } else {
      history.goBack();
    }
  }

  validateEmails = emailsString => {
    if (emailsString)
      return emailsString.split(/,|;|\n/).filter(email => email.match(/.+@.+/))
  }

  handleRemoveEmails = () => {
    this.setState({ emails: null, emailsField: null })
  }

  Integrations = () => {
    const { lists: { integrations: { useLoad, items } } } = useIntegrationStore()
    const [integrations, setIntegrations] = useState([])

    useLoad()

    useEffect(() => {
      const options = (items || [])
        .filter(({ integration_type }) => integration_type === "unsubscribe")
        .map(integration => ({ value: integration.id, label: integration.description }))
      setIntegrations(options)
    }, [items])

    return <Col>
      <FormGroup>
        <Label>Integrations</Label>
        <Select name="integrationId" options={integrations} value={this.state.integrationId}
        handleOnChange={option => this.setState({ integrationId: option?.value || null })} />
      </FormGroup>
    </Col>
  }

  render() {
    return (
      <Formsy onValidSubmit={this.handleValidSubmit}>
        <SheetBody className='border-t-0'>
          <Row>
            <this.Integrations />
            <Col>
              <FormGroup>
                <Label>
                  Emails ({`${this.state.emailsField && this.state.emailsField.length || 0}/${emailsAreaMaxLength}`})
                  <DefaultTooltip content='One e-mail per line or separated by comma or semicolon.'>
                    <Info size={16} />
                  </DefaultTooltip>
                </Label>
                <Textarea type="textarea" rows="8" maxLength={emailsAreaMaxLength} name="emails" onChange={this.handleEmailsChange(false)} value={this.state.emailsField} disabled={this.state.emailsField === null} />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label>
                  Or upload a text file
                  <DefaultTooltip content='A plain text file (.txt) with one e-mail per line or separated by comma or semicolon. Not support CSV or TSV file extensions.'>
                    <Info size={16} />
                  </DefaultTooltip>
                </Label>
                <FileUploader
                  onLoadEmails={this.handleEmailsChange(true)}
                  onRemoveFile={this.handleRemoveEmails}
                />
              </FormGroup>
            </Col>
            <Col>
              {this.state.emails && <Badge size='lg' color='accent' variant='light'>
                Emails found: {this.state.emails.length}
              </Badge>}
            </Col>
          </Row>
        </SheetBody>
        <SheetFooter>
          <Button onClick={this.handleCancel} variant='ghost'>Cancel</Button>
          <Button type="submit" color="accent">Save</Button>
        </SheetFooter>
      </Formsy>
    )
  }
}

UnsubscribeForm.propTypes = {
  handleSubmit: PropTypes.func,
  data: PropTypes.any,
};

export default UnsubscribeForm;
